/** Updates sidebar branding from system_name setting. */
export function applySystemBranding(name) {
    const trimmed = typeof name === 'string' ? name.trim() : '';
    if (!trimmed) return;

    const el = document.getElementById('sidebar-system-name');
    if (el) {
        el.textContent = trimmed;
        el.title = trimmed;
    }
    if (document.body) {
        document.body.dataset.systemName = trimmed;
    }
}

/** Applies branding from server-rendered data-system-name on <body>. */
export function initSystemBranding() {
    const fromBody = document.body?.dataset?.systemName;
    if (fromBody) {
        applySystemBranding(fromBody);
    }
}
